<template>
    <span :style="'line-height: '+(lineHeight || 22)+'px;text-align: left; background: #fff'">
        <b>{{title}}</b>
        <span v-if="showMore">
            {{words.slice(0, len).join(sep)}}
        </span>
        <span v-else>
            {{text}} <span style="opacity: 0">.</span>
        </span>
        <a-space v-if="showIcon">
            <a  v-if="noIcon" @click="handleChange" :style="'margin-left: 5px; font-size: '+(tipSize || 18)+'px'" class="paper-primary-text">
                <span v-if="showMore">
                    {{moreText}}
                </span>
                <span v-else>
                    {{lessText}}
                </span>
            </a>
            <span v-if="extraTitle">
                <a v-if="!showMore" :style="'margin-right: 10px; font-size: '+(tipSize || 18)+'px'"  class="paper-primary-text" @click="toggleExtra">
                {{extraTitle}}
                <UpOutlined v-if="showExtra"/>
                <DownOutlined v-else/>
            </a>
            </span>
        </a-space>


    </span>
    <template v-if="showExtra">
        <slot name="extra"></slot>
    </template>
</template>

<script>
    import {defineEmits} from 'vue';
    import { DownOutlined, UpOutlined} from '@ant-design/icons-vue';
    const emit = defineEmits(['show', 'hide']);
    export default {
        name: "MoreORLess",
        components: {
            DownOutlined, UpOutlined
        },
        props: ['len', 'noTip', 'text', 'title', 'lineHeight', 'moreText', 'lessText', 'noIcon', 'tipSize',
            'extraTitle', 'showExtraText'],
        data(){
            let {text, len} = this;
            text = text || '';
            let sep = this.title? "": '';
            let words = text.split(sep);
            return {
                words,
                sep,
                showIcon: words.length > len,
                showMore: true,
                tipText: this.moreText || 'Show more',
                showExtra: false
            }
        },
        watch: {
            text: function(newValue, oldValue){
                if(newValue !== oldValue){
                    this.words = newValue.split(this.sep);
                }
            },

            showExtraText: function(newValue){
                if(newValue){
                    this.show = true;
                    this.showExtra = true;
                }
            }
        },
        methods: {
            toggleExtra(){
                this.showExtra = !this.showExtra;
                if(this.showExtra) emit('show', this.showExtra)
            },
            handleChange(){
                let {showMore} = this;
                this.showMore = !showMore;
                this.tipText = showMore? (this.moreText || 'Show more'): (this.lessText || 'Show less');
            }
        }
    }
</script>

<style scoped>
    .paper-primary-text {
        color: #576B95!important;
    }
</style>
